import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { EDS } from "../theme";

const SIZES = {
  sm: {
    primary: "1.0625rem",
    sub: "0.6875rem",
    gap: 0.15,
    subTracking: "0.08em",
  },
  md: {
    primary: "1.1875rem",
    sub: "0.75rem",
    gap: 0.2,
    subTracking: "0.07em",
  },
  lg: {
    primary: "1.4375rem",
    sub: "0.8125rem",
    gap: 0.25,
    subTracking: "0.06em",
  },
};

export default function EdsWordmark({ light, compact, size }) {
  const ink = light ? "#fff" : EDS.ink;
  const sub = light ? "rgba(255,255,255,0.55)" : EDS.subtle;
  const resolvedSize = compact ? "sm" : size || "md";
  const scale = SIZES[resolvedSize] || SIZES.md;

  return (
    <Box
      sx={{
        lineHeight: 1,
        display: "inline-flex",
        flexDirection: "column",
        gap: scale.gap,
      }}
    >
      <Box
        component="span"
        sx={{
          display: "block",
          color: ink,
          fontWeight: 500,
          fontSize: scale.primary,
          letterSpacing: "-0.035em",
        }}
      >
        Elite Drive
      </Box>
      {!compact ? (
        <Box
          component="span"
          sx={{
            display: "block",
            color: sub,
            fontSize: scale.sub,
            fontWeight: 400,
            letterSpacing: scale.subTracking,
            textTransform: "uppercase",
          }}
        >
          Solutions
        </Box>
      ) : null}
    </Box>
  );
}

EdsWordmark.propTypes = {
  light: PropTypes.bool,
  compact: PropTypes.bool,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
};

EdsWordmark.defaultProps = {
  light: false,
  compact: false,
  size: "md",
};
